// INSPECTION TYPE
export const GET_INSPECTION_TYPES = '/inspection-types/query';
export const GET_INSPECTION_TYPE = '/inspection-types/';
export const POST_INSPECTION_TYPE = '/inspection-types/';
export const PUT_INSPECTION_TYPE = '/inspection-types/';
export const DELETE_INSPECTION_TYPE = '/inspection-types/';
export const CHECK_INSPECTION_TYPE_EXISTS = '/inspection-types/query';
